import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Loai bệnh phẩm",
    name: "tenLoaiBP",
    rules: [{required: true, message: "Chưa nhập loại bệnh phẩm"}],
  },
  {
    type: INPUT,
    label: "Mô tả",
    name: "moTa",
    // rules: [{required: true, message: "Chưa nhập "}],
  },
];
export {dataFields};
